export const fieldWidth = {
  small: '80px',
  medium: '110px',
  long: '150px',
  extraLong: '200px'
} as const
